export default "__VITE_ASSET__BkBrqEYD__$_?url__"